export default {
  title: "Node Agent Dashboard"
};
